import { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "../api/axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem("adminhub_admin");
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  const persist = (token, adminData) => {
    localStorage.setItem("adminhub_token", token);
    localStorage.setItem("adminhub_admin", JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.admin);
    return data.admin;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("adminhub_token");
    localStorage.removeItem("adminhub_admin");
    setAdmin(null);
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("adminhub_admin", JSON.stringify(data.admin));
      setAdmin(data.admin);
    } catch {
      logout();
    }
  }, [logout]);

  useEffect(() => {
    const token = localStorage.getItem("adminhub_token");
    if (token) {
      refreshMe().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const can = useCallback(
    (permissionKey) => {
      if (!admin) return false;
      if (admin.role === "superadmin") return true;
      return admin.permissions?.includes(permissionKey);
    },
    [admin]
  );

  const isSuperAdmin = admin?.role === "superadmin";

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, refreshMe, can, isSuperAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
